import { render, staticRenderFns } from "./AddEditSupplier.vue?vue&type=template&id=51385ecc&"
import script from "./AddEditSupplier.vue?vue&type=script&lang=js&"
export * from "./AddEditSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports